// helpers/imgPath.js
export const imgPath = codigo => `/img/articulos/comprimidas/cod-${codigo}.webp`;
